var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterCooler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.03959,
    y: 0.455114,
    width: 20.778,
    height: 13.6618,
    rx: 0.758523,
    stroke: "#D6B1FF",
    strokeWidth: 0.910227
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.26979C0 3.59952 0.543364 3.05615 1.21364 3.05615H19.1332C19.8035 3.05615 20.3469 3.59952 20.3469 4.26979V15.2342C20.3469 15.9044 19.8035 16.4478 19.1332 16.4478H6.13146L2.5083 20.0004V16.4478H1.21364C0.543363 16.4478 0 15.9044 0 15.2342V4.26979ZM5.15603 11.5282C6.00267 11.5282 6.68901 10.8552 6.68901 10.0251C6.68901 9.1949 6.00267 8.52192 5.15603 8.52192C4.30939 8.52192 3.62305 9.1949 3.62305 10.0251C3.62305 10.8552 4.30939 11.5282 5.15603 11.5282ZM11.7066 10.0251C11.7066 10.8552 11.0203 11.5282 10.1736 11.5282C9.32696 11.5282 8.64062 10.8552 8.64062 10.0251C8.64062 9.1949 9.32696 8.52192 10.1736 8.52192C11.0203 8.52192 11.7066 9.1949 11.7066 10.0251ZM15.1907 11.5282C16.0373 11.5282 16.7237 10.8552 16.7237 10.0251C16.7237 9.1949 16.0373 8.52192 15.1907 8.52192C14.3441 8.52192 13.6577 9.1949 13.6577 10.0251C13.6577 10.8552 14.3441 11.5282 15.1907 11.5282Z",
    fill: "#2EC5CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterCooler);
export default __webpack_public_path__ + "static/media/WaterCooler.452bfbe714f5d0d5fb00e0d82a5858c0.svg";
export { ForwardRef as ReactComponent };